export default __webpack_public_path__ + "static/media/package_for_return_to_sender.24ee0b76.png";